var _circle, _path, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    fill: "white",
    stroke: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9228 21.2695L23.6543 16.5H19.0781V13.4062C19.0781 12.1011 19.7162 10.8281 21.7658 10.8281H23.8477V6.76758C23.8477 6.76758 21.9592 6.44531 20.1545 6.44531C16.384 6.44531 13.9219 8.73018 13.9219 12.8648V16.5H9.73242V21.2695H13.9219V32.8002C14.763 32.9323 15.6234 33 16.5 33C17.3766 33 18.237 32.9323 19.0781 32.8002V21.2695H22.9228Z",
    fill: "#1877F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    stroke: "#E8E8E8"
  })));
};

export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjE2LjUiIGN5PSIxNi41IiByPSIxNiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iI0U4RThFOCIvPgogICAgPHBhdGggZD0iTTIyLjkyMjggMjEuMjY5NUwyMy42NTQzIDE2LjVIMTkuMDc4MVYxMy40MDYyQzE5LjA3ODEgMTIuMTAxMSAxOS43MTYyIDEwLjgyODEgMjEuNzY1OCAxMC44MjgxSDIzLjg0NzdWNi43Njc1OEMyMy44NDc3IDYuNzY3NTggMjEuOTU5MiA2LjQ0NTMxIDIwLjE1NDUgNi40NDUzMUMxNi4zODQgNi40NDUzMSAxMy45MjE5IDguNzMwMTggMTMuOTIxOSAxMi44NjQ4VjE2LjVIOS43MzI0MlYyMS4yNjk1SDEzLjkyMTlWMzIuODAwMkMxNC43NjMgMzIuOTMyMyAxNS42MjM0IDMzIDE2LjUgMzNDMTcuMzc2NiAzMyAxOC4yMzcgMzIuOTMyMyAxOS4wNzgxIDMyLjgwMDJWMjEuMjY5NUgyMi45MjI4WiIgZmlsbD0iIzE4NzdGMiIvPgogICAgPGNpcmNsZSBjeD0iMTYuNSIgY3k9IjE2LjUiIHI9IjE2IiBzdHJva2U9IiNFOEU4RTgiLz4KPC9zdmc+Cg==";